<template>
  <ion-page>
    <ion-content scroll-y="false" :fullscreen="true">
      <div id="container">
        <ion-list lines="full" class="ion-no-margin">
          <ion-item>
            <ion-label> Update App </ion-label>
          </ion-item>
          <ion-item text-center>
            <ion-label class="ion-text-wrap">
              This app is out of date, please update to continue using it
            </ion-label>
          </ion-item>
        </ion-list>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { IonContent, IonPage, IonList, IonLabel, IonItem } from "@ionic/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "UpdateApp",
  components: {
    IonContent,
    IonPage,
    IonList,
    IonLabel,
    IonItem,
  },
});
</script>

<style scoped>
ion-menu-button {
  color: var(--ion-color-primary);
}

#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
</style>